import { getGlobalSupport, parseUrlToObj, getTimestamp, htmlElementAsString } from '../utils/unils.js';
import { breadcrumb } from './breadcrumb.js';
import { options } from './option.js';
import { USERTRACKTYPE, USERLOGTYPE, BREADCRUMBTYPES, STATUS_CODE } from '../utils/enum.js';
import { getLogString } from '../track/index.js';

let mirrorUserLogIns = null;
const _support = getGlobalSupport();
// 堆栈行为日志,关联配置项
function isUseReplace(key) {
    const USER_LOG_HANDLE_LIST = (options === null || options === void 0 ? void 0 : options.config['user-log']) || null;
    if (!USER_LOG_HANDLE_LIST)
        return false;
    return USER_LOG_HANDLE_LIST.find(item => item === key);
}
// 不等于log的情况表示肯定开启了indexDb的存储
function isUseTrack() {
    return (_support === null || _support === void 0 ? void 0 : _support.logType) !== 'log';
}
class MirrorUserLogHandle {
    constructor() { }
    handleHistory(data) {
        const { from, to } = data;
        // 定义parsedFrom变量，值为relative
        const { relative: parsedFrom } = parseUrlToObj(from);
        const { relative: parsedTo } = parseUrlToObj(to);
        // track记录
        if (isUseTrack()) {
            getLogString(USERTRACKTYPE.HISTORY, 'history跳转', {
                from: parsedFrom ? parsedFrom : '/',
                to: parsedTo ? parsedTo : '/',
                url: location.href
            });
        }
        // 推送用户行为日志堆栈
        if (isUseReplace(USERLOGTYPE.HISTORY)) {
            breadcrumb.push({
                category: BREADCRUMBTYPES.HISTORY,
                status: STATUS_CODE.OK,
                time: getTimestamp(),
                msg: {
                    from: parsedFrom ? parsedFrom : '/',
                    to: parsedTo ? parsedTo : '/'
                }
            });
        }
    }
    handleHashChange(e) {
        const { oldURL, newURL } = e;
        const { relative: from } = parseUrlToObj(oldURL);
        const { relative: to } = parseUrlToObj(newURL);
        // track记录
        if (isUseTrack()) {
            getLogString(USERTRACKTYPE.HASHCHANGE, 'hashChange跳转', { from, to, url: location.href });
        }
        // 推送用户行为日志堆栈
        if (isUseReplace(USERLOGTYPE.HASH)) {
            breadcrumb.push({
                category: BREADCRUMBTYPES.HASHCHANGE,
                status: STATUS_CODE.OK,
                time: getTimestamp(),
                msg: {
                    from,
                    to
                }
            });
        }
    }
    handleDomClick(e) {
        const htmlString = htmlElementAsString(e);
        if (htmlString) {
            // track记录
            if (isUseTrack()) {
                getLogString(USERTRACKTYPE.CLICK, '点击', { dom: htmlString, url: location.href });
            }
            // 推送用户行为日志堆栈
            if (isUseReplace(USERLOGTYPE.DOM)) {
                breadcrumb.push({
                    category: BREADCRUMBTYPES.CLICK,
                    status: STATUS_CODE.OK,
                    time: getTimestamp(),
                    msg: {
                        clickDom: htmlString
                    }
                });
            }
        }
    }
    handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // track记录
        if (isUseTrack()) {
            getLogString(USERTRACKTYPE.SCROLL, '页面滚动', { top: scrollTop, url: location.href });
        }
        // 推送用户行为日志堆栈
        if (isUseReplace(USERLOGTYPE.SCROLL)) {
            breadcrumb.push({
                category: BREADCRUMBTYPES.SCROLL,
                status: STATUS_CODE.OK,
                time: getTimestamp(),
                msg: {
                    top: scrollTop
                }
            });
        }
    }
    handleJsError(data) {
        // track记录
        if (isUseTrack()) {
            getLogString(USERTRACKTYPE.ERROR, 'js报错', { message: data.message, url: location.href });
        }
        // 推送用户行为日志堆栈
        if (isUseReplace(USERLOGTYPE.JS)) {
            breadcrumb.push({
                category: BREADCRUMBTYPES.ERROR,
                status: STATUS_CODE.ERROR,
                time: data.time || getTimestamp(),
                msg: {
                    message: data.message
                }
            });
        }
    }
    handlePromiseError(data) {
        // track记录
        if (isUseTrack()) {
            getLogString(USERTRACKTYPE.UNHANDLEDREJECTION, 'rejection错误', { message: data.message, url: location.href });
        }
        // 推送用户行为日志堆栈
        if (isUseReplace(USERLOGTYPE.PROMISE)) {
            breadcrumb.push({
                category: BREADCRUMBTYPES.UNHANDLEDREJECTION,
                status: STATUS_CODE.ERROR,
                time: data.time || getTimestamp(),
                msg: {
                    message: data.message
                }
            });
        }
    }
    handleResourceError(data) {
        // track记录
        if (isUseTrack()) {
            getLogString(USERTRACKTYPE.RESOURCE, 'resource错误', {
                message: data.message,
                name: data === null || data === void 0 ? void 0 : data.name,
                url: location.href
            });
        }
        // 推送用户行为日志堆栈
        if (isUseReplace(USERLOGTYPE.RESOURCE)) {
            breadcrumb.push({
                category: BREADCRUMBTYPES.RESOURCE,
                status: STATUS_CODE.ERROR,
                time: data.time || getTimestamp(),
                msg: {
                    message: data.message,
                    name: data === null || data === void 0 ? void 0 : data.name
                }
            });
        }
    }
    handleWhiteScreen() {
        // track记录
        if (isUseTrack()) {
            getLogString(USERTRACKTYPE.WHITE, '白屏错误', { url: location.href });
        }
        // 推送用户行为日志堆栈
        if (isUseReplace(USERLOGTYPE.WHITE)) {
            breadcrumb.push({
                category: BREADCRUMBTYPES.WHITE,
                status: STATUS_CODE.ERROR,
                time: getTimestamp(),
                msg: {
                    url: location.href
                }
            });
        }
    }
    handleRequest(data) {
        var _a, _b, _c, _d;
        // track记录
        if (isUseTrack()) {
            getLogString(isSuccessfulRequest(data.httpCode), `请求httpCode:${data.httpCode}`, {
                api: data === null || data === void 0 ? void 0 : data.api,
                traceId: ((_a = data === null || data === void 0 ? void 0 : data.headers) === null || _a === void 0 ? void 0 : _a['X-Bili-Trace-Id']) || ((_b = data === null || data === void 0 ? void 0 : data.headers) === null || _b === void 0 ? void 0 : _b['Bili-Trace-Id']) || '',
                code: data === null || data === void 0 ? void 0 : data.code,
                message: data === null || data === void 0 ? void 0 : data.msg,
                url: location.href
            });
        }
        // 推送用户行为日志堆栈
        if (isUseReplace(USERLOGTYPE.API)) {
            breadcrumb.push({
                category: BREADCRUMBTYPES.API,
                status: isSuccessfulRequest(data.httpCode),
                time: getTimestamp(),
                msg: {
                    api: data === null || data === void 0 ? void 0 : data.api,
                    traceId: ((_c = data === null || data === void 0 ? void 0 : data.headers) === null || _c === void 0 ? void 0 : _c['X-Bili-Trace-Id']) || ((_d = data === null || data === void 0 ? void 0 : data.headers) === null || _d === void 0 ? void 0 : _d['Bili-Trace-Id']) || '',
                    code: data === null || data === void 0 ? void 0 : data.code,
                    message: data === null || data === void 0 ? void 0 : data.msg
                }
            });
        }
    }
}
if (!mirrorUserLogIns) {
    mirrorUserLogIns = new MirrorUserLogHandle();
}
function isSuccessfulRequest(httpCode) {
    if (!httpCode) {
        return USERTRACKTYPE.APIUNKNOWN;
    }
    else {
        return httpCode >= 200 && httpCode < 300 ? USERTRACKTYPE.APISUCCESS : USERTRACKTYPE.APIERROR;
    }
}

export { mirrorUserLogIns };
